
<template>
    <div class="reset-page">
        <div class="global_popup_header">重置密码</div>
        <div class="global_popup_body">
            <el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm" @submit.native.prevent>
                <el-form-item label="新密码" prop="newPass">
                    <el-input v-model="ruleForm.newPass" type="password" @keyup.enter.native="submitForm('ruleForm')" placeholder="新密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPass"> 
                    <el-input v-model="ruleForm.confirmPass" type="password" @keyup.enter.native="submitForm('ruleForm')" placeholder="确认密码"></el-input>
                </el-form-item>
                <span @click="$router.push({name: 'login'})" class="btn-wrap">登录</span>                   
            </el-form>
        </div>
        <div class="global_popup_footer">
            <button @click="submitForm('ruleForm')">{{$t('commonMsg.confirm')}}</button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Reset',
    data() {
        return {
            ruleForm: {
                newPass: '',
                confirmPass: ''

            },
            rules: {
                newPass: [{required: true, message: '请填写新密码', trigger: 'blur'}],
                confirmPass: [{required: true, message: '请填写确认密码', trigger: 'blur'}]
            }            
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.resetPass()
                } else {
                    return false;
                }
            })
        },

        resetPass(){
            this.$http.resetPass({password: this.ruleForm.newPass}, this.$route.query.token)
            .then(res => {
                this.$message({type: 'success', message: '密码修改成功'})
            })
            .catch(() => {})
        }
    }
}
</script>

<style lang="scss" scoped>
    .reset-page {
        @include globalPopup(460px, 390px);
        .global_popup_body{
            .btn-wrap{
                cursor: pointer;
            }
        }
    }
</style>


